import { createContext } from 'react';

const layoutContext = createContext({
    extended: false,
    setExtended: () => {},
});

export default layoutContext;
